// import React from "react";
// import Routing from "./routing/Routing";
// import Language from "./components/Language";

// const App = () => {
//   return (
//     <>
//       <Routing />
//       <Language />
//     </>
//   );
// };

// export default App;

import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Routing from "./routing/Routing";
import Language from "./components/Language";

const App = () => {
  return (
    <>
      <Routing />
      <Language />

      {/* Toast notifications container */}
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default App;
